export const LayoutIndent = 40;
export const HeaderPadding = 1;
